import { createContext, PropsWithChildren, useContext } from "react";
import { TravelerPickerProps } from "../mobile/components/common/TravelerPicker/TravelerPicker";

const TravelerPickerContextV2 = createContext<TravelerPickerProps>(null!);

export default function TravelerPickerProviderV2({
  children,
  ...props
}: PropsWithChildren<TravelerPickerProps>) {
  return (
    <TravelerPickerContextV2.Provider value={props}>
      {children}
    </TravelerPickerContextV2.Provider>
  );
}

export function useTravelerPickerContextV2() {
  const context = useContext(TravelerPickerContextV2);

  if (!context) {
    throw new Error(
      "useTravelerPickerContextV2 must be used within a TravelerPickerProviderV2"
    );
  }

  return context;
}
